import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { ImageCropperModule } from 'ngx-image-cropper';
import { NgxMaskModule } from 'ngx-mask';
import { NgxQRCodeModule } from '@techiediaries/ngx-qrcode';
import { PipesModule } from '../pipes/pipes.module';

import { CardProductsComponent } from './card-products/card-products.component';
import { GridCardComponent } from './grid-card/grid-card.component';
import { ListCardComponent } from './list-card/list-card.component';

import { CropperComponent } from './cropper/cropper.component';
import { CustomerDocumentModalComponent } from './customer-document-modal/customer-document-modal.component';
import { CustomerPhoneModalComponent } from './customer-phone-modal/customer-phone-modal.component';
import { PasswordToggleComponent } from './password-toggle/password-toggle.component';
import { PlaceSelectModalComponent } from './place-select-modal/place-select-modal.component';
import { ProductAddressesComponent } from './product-addresses/product-addresses.component';
import { TextInputModalComponent } from './product-addresses/text-input-modal.component';
import { SelectorComponent } from './selector/selector.component';
import { ViewCheckoutComponent } from './view-checkout/view-checkout.component';
import { GradientBackgroundComponent } from './gradient-background/gradient-background.component';
import { CustomSelectComponent } from './custom-select/custom-select.component';
import { AccountStatusModalComponent } from './account-status-modal/account-status-modal.component';
import { CardActionsPopoverComponent } from './card-actions-popover/card-actions-popover.component';
import { StoreShareModalComponent } from './store-share-modal/store-share-modal.component';
import { DifferentSellerModalComponent } from './different-seller-modal/different-seller-modal.component';
import { ProductCharacteristicsComponent } from './product-characteristics/product-characteristics.component';
import { ProductCharacteristicsFilterComponent } from './product-characteristics-filter/product-characteristics-filter.component';
import { FreeShippingBadgeComponent } from './free-shipping-badge/free-shipping-badge.component';

@NgModule({
  declarations: [
    ViewCheckoutComponent,
    PasswordToggleComponent,
    PlaceSelectModalComponent,
    ProductAddressesComponent,
    SelectorComponent,
    TextInputModalComponent,
    CropperComponent,
    CardProductsComponent,
    ListCardComponent,
    GridCardComponent,
    GradientBackgroundComponent,
    CustomSelectComponent,
    CustomerDocumentModalComponent,
    CustomerPhoneModalComponent,
    AccountStatusModalComponent,
    CardActionsPopoverComponent,
    StoreShareModalComponent,
    DifferentSellerModalComponent,
    ProductCharacteristicsComponent,
    ProductCharacteristicsFilterComponent,
    FreeShippingBadgeComponent,
  ],
  exports: [
    ViewCheckoutComponent,
    PasswordToggleComponent,
    PlaceSelectModalComponent,
    ProductAddressesComponent,
    SelectorComponent,
    TextInputModalComponent,
    CropperComponent,
    CardProductsComponent,
    ListCardComponent,
    GridCardComponent,
    GradientBackgroundComponent,
    CustomSelectComponent,
    CustomerDocumentModalComponent,
    CustomerPhoneModalComponent,
    AccountStatusModalComponent,
    CardActionsPopoverComponent,
    StoreShareModalComponent,
    DifferentSellerModalComponent,
    ProductCharacteristicsComponent,
    ProductCharacteristicsFilterComponent,
    FreeShippingBadgeComponent,
  ],
  imports: [CommonModule, IonicModule, FormsModule, ReactiveFormsModule, ImageCropperModule, NgxMaskModule, NgxQRCodeModule, PipesModule],
})
export class ComponentsModule {}
